/**
 * Module-level site context — read by apiRequest and stamped onto every
 * outgoing API call as the X-Site-Context header. Pages that "live in a
 * specific site" (most of ClinOps Site Detail) set this on mount and
 * clear on unmount. Pages without a site context (the global Documents
 * list, the global Worklist, etc.) just don't set it.
 *
 * Why a singleton instead of a React Context: apiRequest is a plain
 * function called from React Query queryFn/mutationFn closures and
 * from non-component code (presigned uploads, etc.). It can't read
 * React context. A module-level value keeps the consumer signature
 * unchanged while giving us a single source of truth.
 *
 * The backend reads the header in capture_site_context (auth/deps.py)
 * and stamps the value into AuditEvent payload as site_id; the audit
 * log resolver prefers that explicit value over the entity-walk
 * fallback.
 */

let _currentSiteContext: string | null = null;

export function setSiteContext(siteId: string | null): void {
  _currentSiteContext = siteId;
}

export function getSiteContext(): string | null {
  return _currentSiteContext;
}
